export enum DisplayStatus {
  DISPLAYED = "진열 중",
  NOT_DISPLAYED = "진열 안함",
}
